// extracted by mini-css-extract-plugin
export var dropdownButton = "_y-0";
export var fullWidthDropdownButton = "_y-1";
export var icon = "_y-3";
export var iconPlaceholder = "_y-2";
export var menuItemRow = "_y-9";
export var separator = "_y-e";
export var shortcutContainer = "_y-7";
export var shortcutContainerFilled = "_y-8";
export var shortcutIconLg = "_y-6";
export var shortcutIconMd = "_y-5";
export var shortcutIconSm = "_y-4";
export var submenuChevron = "_y-d";
export var submenuDropdown = "_y-a";
export var submenuTriggerRow = "_y-b";
export var submenuTriggerRowOpen = "_y-c";